import React from 'react';
import { Link } from 'react-router-dom';
import { normalizeSidebarHref } from '@/core/context/sidebar/sidebar.utils';

interface AppNavLinkProps {
    href: string;
    className?: string;
    children: React.ReactNode;
    onClick?: () => void;
}

const AppNavLink: React.FC<AppNavLinkProps> = ({ href, className, children, onClick }) => {
    const normalizedHref = normalizeSidebarHref(href);

    return (
        <Link to={normalizedHref} className={className} onClick={onClick}>
            {children}
        </Link>
    );
};

export default AppNavLink;
